export default __webpack_public_path__ + "static/media/142-virement.8bb49ac1.svg";